/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { l as n, s as t } from "../chunks/vec3.js";
import { s as r } from "../chunks/vec4.js";
var u = new Float32Array(1);

function a(n) {
  --n;

  for (var _t = 1; _t < 32; _t <<= 1) {
    n |= n >> _t;
  }

  return n + 1;
}

function e(n, t, r) {
  return Math.min(Math.max(n, t), r);
}

function i(n, t) {
  return 0 === t ? 0 : Math.round(n / t) * t;
}

function o(n) {
  return 0 == (n & n - 1);
}

function c(n) {
  return n--, n |= n >> 1, n |= n >> 2, n |= n >> 4, n |= n >> 8, n |= n >> 16, ++n;
}

function f(n) {
  return Math.pow(10, Math.ceil(Math.LOG10E * Math.log(n)));
}

function s(n, t, r) {
  return n + (t - n) * r;
}

function h(n, t, r, u, a) {
  return s(u, a, (n - t) / (r - t));
}

function M(n) {
  return n * Math.PI / 180;
}

function m(n) {
  return 180 * n / Math.PI;
}

function N(n) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e-6;
  return (n < 0 ? -1 : 1) / Math.max(Math.abs(n), t);
}

function l(n) {
  return Math.acos(e(n, -1, 1));
}

function b(n) {
  return Math.asin(e(n, -1, 1));
}

function x(n, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e-6;
  if (isNaN(n) || isNaN(t)) return !1;
  if (n === t) return !0;
  var u = Math.abs(n - t),
      a = Math.abs(n),
      e = Math.abs(t);

  if (0 === n || 0 === t || a < 1e-12 && e < 1e-12) {
    if (u > .01 * r) return !1;
  } else if (u / (a + e) > r) return !1;

  return !0;
}

function p(n, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e-6;
  if (isNaN(n) || isNaN(t)) return !1;
  return (n > t ? n - t : t - n) <= r;
}

function j(n) {
  return k(Math.max(-w, Math.min(n, w)));
}

function k(n) {
  return u[0] = n, u[0];
}

function v(n, t) {
  return t < n ? 0 : 1;
}

function I(n, t, r) {
  var u = e((r - n) / (t - n), 0, 1);
  return u * u * (3 - 2 * u);
}

function P(r, u) {
  var a = n(r),
      e = b(r[2] / a),
      i = Math.atan2(r[1] / a, r[0] / a);
  return t(u, a, e, i), u;
}

function d(n, r) {
  var u = n[0],
      a = n[1],
      e = n[2],
      i = Math.cos(a);
  t(r, u * i * Math.cos(e), u * i * Math.sin(e), u * Math.sin(a));
}

function g(n, t, u) {
  return r(n, t[0], t[1], t[2], t[3] * u);
}

var w = k(34028234663852886e22);
export { w as NUMBER_MAX_FLOAT32, l as acosClamped, g as applyOpacity, b as asinClamped, P as cartesianToSpherical, e as clamp, j as clampFloat32, M as deg2rad, p as floatEqualAbsolute, x as floatEqualRelative, o as isPowerOfTwo, s as lerp, f as nextHighestPowerOfTen, a as nextHighestPowerOfTwo, c as nextPowerOfTwo, m as rad2deg, N as reciprocalClamped, i as roundToNearest, h as scale, I as smoothstep, d as sphericalToCartesian, v as step };